import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ThemeApplier from "@/components/ascend/ThemeApplier";
import ProtectedRoute from "@/components/ascend/ProtectedRoute";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Subjects from "@/pages/Subjects";
import Timetable from "@/pages/Timetable";
import Tasks from "@/pages/Tasks";
import Checkin from "@/pages/Checkin";
import Journal from "@/pages/Journal";
import GratitudeWall from "@/pages/GratitudeWall";
import Reflection from "@/pages/Reflection";
import ThemeStudio from "@/pages/ThemeStudio";
import ShareCompose from "@/pages/ShareCompose";
import PublicShare from "@/pages/PublicShare";
import DreamBoard from "@/pages/DreamBoard";
import MusicPage from "@/pages/MusicPage";
import Admin from "@/pages/Admin";
import News from "@/pages/News";
import NewsSaved from "@/pages/NewsSaved";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-hand text-xl text-muted">a moment…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return <Navigate to="/dashboard" replace />;
}

function OnboardingGate({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.onboarding_completed) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <ThemeApplier>
              <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/onboarding" element={<OnboardingGate><Onboarding /></OnboardingGate>} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/subjects" element={<ProtectedRoute><Subjects /></ProtectedRoute>} />
                <Route path="/timetable" element={<ProtectedRoute><Timetable /></ProtectedRoute>} />
                <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
                <Route path="/checkin" element={<ProtectedRoute><Checkin /></ProtectedRoute>} />
                <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
                <Route path="/gratitude" element={<ProtectedRoute><GratitudeWall /></ProtectedRoute>} />
                <Route path="/reflection" element={<ProtectedRoute><Reflection /></ProtectedRoute>} />
                <Route path="/studio" element={<ProtectedRoute><ThemeStudio /></ProtectedRoute>} />
                <Route path="/share" element={<ProtectedRoute><ShareCompose /></ProtectedRoute>} />
                <Route path="/dreamboard" element={<ProtectedRoute><DreamBoard /></ProtectedRoute>} />
                <Route path="/music" element={<ProtectedRoute><MusicPage /></ProtectedRoute>} />
                <Route path="/news" element={<ProtectedRoute><News /></ProtectedRoute>} />
                <Route path="/news/saved" element={<ProtectedRoute><NewsSaved /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                <Route path="/s/:token" element={<PublicShare />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ThemeApplier>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
